window.jQuery = window.$ = require('jquery');
require('velocity-animate');
require('slick-carousel');
require('vue');

// Global
require('./features/site-header');
require('./features/common');

require('./features/hero-carousel');
require('./features/spotlight-carousel');
require('./features/featured-capabilities');
require('./features/featured-practices');
require('./features/back-to-top');
require('./features/insights-adv-search');
require('./features/explorer-bar');
require('./features/splash-intro');
require('./features/home-intro');
require('./features/overview-expand');
require('./features/accordions');
require('./features/people-search');
require('./features/featured-services');
require('./features/service-column');
require('./features/site-search');
require('./features/featured-collapsible');
require('./features/AlertBanner');
require('./features/icon-content-grids');
require('./features/featured-video-carousels');
require('./features/featured-content-panels');
require('./features/statistics-grids');
require('./features/careers-tabs');
require('./features/flexible-cards');
require('./features/popup-modal');
require('./features/pronunciations');
require('./features/attorney-carousel');
require('./features/home-site-search-module');